import moment from 'moment';
import { getData } from '@/components/report/service';
import  { computeWeight } from '@/utils/query';
import { ModalsQuery } from '../Modals/Filter';
import { crudRequest } from '@/services/api';

export default {
  namespace: 'outletsdepartStorehouseModals',
  state: {
    modalsVisible: false,
    /**
     * @modalsType
     * 1: 一派留仓总票数
     * 2: 二派留仓总票数
    */
    modalsType: '',
    modalsTitle: '',
    modalsSite: '',
    modalsList: [],
    centerFilter: '',
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          modalsVisible: false,
          modalsList: []
        },
      });
    },
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/outletsdepartStorehouse/search_detail')   // 日志
      yield put({ type: 'getModalData' });
    },
    *getModalData(_, { call, put, select }) {
      let query = yield select(({ outletsdepartStorehouse }) => {
        const { endDate } = outletsdepartStorehouse.filter;
        return {
          startDate: endDate + ' 00:00:00',
          endDate: endDate + ' 23:59:59',
        }
      });
      const { modalsType, modalsSite, centerFilter } = yield select(({ outletsdepartStorehouseModals }) => outletsdepartStorehouseModals);
      const modalsfilter = ModalsQuery({
        centerFilter,
        destinationSite: modalsSite,
        startDate: query.startDate,
        endDate: query.endDate,
      })
      let filter;
      if (modalsType === 1) {
        filter = modalsfilter[0]
      } else if (modalsType === 2) {
        filter = modalsfilter[1]
      }

      const data = yield call(getData, filter);
      const newData = data || [];
      let ticket = 0;
      newData.forEach((item, index) => {
        item.index = index;
        item.goodsWeight = computeWeight(item.goodsWeight);
        ticket += item.ticket;
      });
      // console.log(111, newData)
      // console.log('总票数:', ticket)
      yield put({
        type: 'update',
        payload: {
          modalsList: newData
        },
      });
    }
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
